import * as React from 'react';

function Beers2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={12} height={15} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.004.55a.873.873 0 00-.656-.3H1.625a.873.873 0 00-.656.3.78.78 0 00-.219.63l.875 12.25a.87.87 0 00.875.82h6.973a.871.871 0 00.875-.82l.875-12.25a.78.78 0 00-.22-.63zm-1.695 3.2H2.664L2.554 2h6.864l-.11 1.75z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Beers2;
